<template>
  <div class="myh-member-audit-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/myh_management/myh_management_home' }">密友会管理</el-breadcrumb-item>
      <el-breadcrumb-item>会员审核</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">筛选条件</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="120px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="审核状态" prop="status">
              <el-select
                v-model="queryForm.status"
                placeholder="请选择审核状态"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
          <el-col :span="2">
            <el-button type="primary" style="width: 100%" @click="handleQuery">查询</el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" style="width: 100%" @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="list_card" style="margin-top: 20px">
      <el-row class="title_row">
        <el-col :span="12">
          <div class="list_title title_class">会员审核</div>
        </el-col>
        <el-col :span="12">
          <div style="text-align: right">
          </div>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="tableData"
        border
        stripe
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="申请人" prop="name" width="180">
          <template slot-scope="scope">
            <div class="name">{{ scope.row.name }}</div>
            <div><i class="el-icon-phone-outline"></i> {{ scope.row.phone }}</div>
            <div><i class="el-icon-message"></i> {{ scope.row.email }}</div>
          </template>
        </el-table-column>
        <el-table-column label="选手状态" prop="memberTypeName" />
        <el-table-column label="会员类型" prop="membershipType" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.membershipType === 'lifetime' ? '' : 'success'" size="mini">
              {{ scope.row.membershipType === 'lifetime' ? '终身会员' : '普通会员' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" prop="payd" />
        <el-table-column label="申请资料" width="240">
          <template slot-scope="scope">
            <el-image
              class="img"
              fit="contain"
              v-for="(item,index) in scope.row.certificateUrls" :key="index" :src="item"
              :preview-src-list="scope.row.certificateUrls">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="教育经历" prop="resume" width="200">
          <template slot-scope="scope">
            <div class="" v-for="(item, i) in eduFn(scope.row.resume)" :key="i">{{ item }}</div>
          </template>
        </el-table-column>
        <el-table-column label="工作经历" prop="resume" width="200">
          <template slot-scope="scope">
            <div class="" v-for="(item, i) in workFn(scope.row.resume)" :key="i">{{ item }}</div>
          </template>
        </el-table-column>
        <el-table-column label="参与过的大型社团活动" prop="activities" width="160">
          <template slot-scope="scope">
            <div class="textarea">{{ scope.row.activities }}</div>
          </template>
        </el-table-column>
        <el-table-column label="兴趣爱好" prop="hobbies" width="160">
          <template slot-scope="scope">
            <div class="textarea">{{ scope.row.hobbies }}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="applyTime" width="100"/>
        <el-table-column label="审核状态" prop="statusName" width="80" fixed="right">
          <template slot-scope="scope">
            <el-tag v-if="+scope.row.status === 0" type="warning" size="mini">待审核</el-tag>
            <el-tag v-else-if="+scope.row.status === 1" type="success" size="mini">通过</el-tag>
            <el-tag v-else-if="+scope.row.status === 2" type="danger" size="mini">拒绝</el-tag>
            <span v-else>{{ scope.row.statusName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              :disabled="+scope.row.status !== 0"
              @click="openAuditDialog(scope.row)"
            >审核</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryForm.pageNum"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 40, 80]"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog title="会员审核" :visible.sync="auditDialogVisible" width="420px">
      <el-form ref="auditFormRef" :model="auditForm" :rules="auditRules" label-width="80px">
        <el-form-item label="审核结果" prop="status">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="+auditForm.status === 2" label="拒绝原因" prop="rejectReason">
          <el-input
            v-model="auditForm.rejectReason"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请输入拒绝原因"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { myhMemberApplyPage, myhMemberApplyReview, myhMemberApplyReviewRefuse } from '@/http/api'

export default {
  name: 'MyhMemberAudit',
  data () {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10
      },
      statusOptions: [
        { label: '待审核', value: 0 },
        { label: '通过', value: 1 },
        { label: '拒绝', value: 2 }
      ],
      tableData: [],
      total: 0,
      auditDialogVisible: false,
      currentRow: null,
      auditForm: {
        id: '',
        status: 1,
        rejectReason: ''
      },
      auditRules: {
        status: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        rejectReason: [
          {
            validator: (rule, value, callback) => {
              if (+this.auditForm.status !== 2) {
                callback()
                return
              }
              if (!value || !String(value).trim()) {
                callback(new Error('请输入拒绝原因'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      myhMemberApplyPage(this.queryForm).then((res) => {
        this.tableData = res.data.list || []
        this.total = res.data.total || 0
      })
    },
    handleQuery () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleReset () {
      this.queryForm.status = ''
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.getList()
    },
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleCurrentChange (page) {
      this.queryForm.pageNum = page
      this.getList()
    },
    openAuditDialog (row) {
      this.currentRow = row
      this.auditForm.id = row.id
      this.auditForm.status = 1
      this.auditForm.rejectReason = ''
      this.auditDialogVisible = true
      this.$nextTick(() => {
        this.$refs.auditFormRef && this.$refs.auditFormRef.clearValidate()
      })
    },
    submitAudit () {
      this.$refs.auditFormRef.validate((valid) => {
        if (!valid) return
        const auditApi = +this.auditForm.status === 1 ? myhMemberApplyReview : myhMemberApplyReviewRefuse
        const params = {
          id: this.auditForm.id
        }
        if (+this.auditForm.status === 2) {
          params.rejectReason = this.auditForm.rejectReason
        }
        auditApi(params).then(() => {
          this.$message.success('审核成功')
          this.auditForm.rejectReason = ''
          this.auditForm.status = 1
          this.auditForm.id = ''
          this.currentRow = null
          this.$refs.auditFormRef && this.$refs.auditFormRef.clearValidate()
          this.auditDialogVisible = false
          this.getList()
        })
      })
    },
    eduFn (resume) {
      if (resume) {
        return JSON.parse(resume).edu
      } else {
        return []
      }
    },
    workFn (resume) {
      if (resume) {
        return JSON.parse(resume).work
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.myh-member-audit-page {
  padding: 0;
}
.filter_Form {
  margin-top: 10px;
}
.name{
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 4px;
}
.img{
  width: 60px;
  height: 60px;
}
.textarea{
  white-space: pre-wrap;
}
</style>
